import React from 'react';
import { BiSearch } from "react-icons/bi";
import './searchBar.css'

function HeaderSearchBar() {
  return (
    <div className="search-bar">
        <BiSearch className="search-icon" />
        <input type="text" placeholder="Recherche" className="search-input" />
    </div>
  )
}

export default HeaderSearchBar